export var MarkupRecursiveList = ['Em', 'Link', 'Strike', 'String', 'Strong', 'User'];
export var MarkupList = [].concat(MarkupRecursiveList, ['Badge', 'Code', 'DateLozenge', 'StatusLozenge', 'Tag', 'UserGroup']);